<!--
 * @Author: qin 15936669602@163.com
 * @Date: 2025-06-28 15:46:40
 * @LastEditors: qin 15936669602@163.com
 * @LastEditTime: 2025-07-05 16:25:22
 * @FilePath: /360-house-viewing-main/src/components/Pagination.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-pagination
    layout="prev, pager, next, jumper"
    :total="totalItems"
    :page-size="itemsPerPage"
    :current-page.sync="currentPage"
    @current-change="handleCurrentChange"
    background
  />
</template>

<script>
export default {
  name: "Pagination",
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit("page-changed", page);
    },
  },
};
</script>

<style lang="scss">
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--primary-color) !important;
  color: #fff !important;
}
</style>
